import { JSX } from "react";
import { Link } from "react-router-dom";

import Project from "@app/projects/project";
import ProjectRunConfiguration from "@app/projects/projectRunConfiguration";
import { ProjectRunStatusEnum } from "@app/projects/enumerators";
import { NetworkIntegrityProvider } from "@app/projects/network-assessment/network-integrity/models/networkIntegrityProvider";
import { NetworkIntegrityAdequacyImpactProvider } from "@app/projects/network-assessment/network-integrity/models/networkIntegrityAdequacyImpactProvider";
import { isHistoricalRun } from "@app/projects/network-assessment/network-integrity/helpers/historicalRunHelper";
import { ResourceType } from "@app/resources";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

const PROVIDER_HUB_UNAVAILABLE_TOOLTIP = "Link to Provider Hub profile is unavailable until processing is complete.";

const generateProviderHubLink = (projectId: string, projectRunConfigurationId: string, provider: NetworkIntegrityProvider | NetworkIntegrityAdequacyImpactProvider): JSX.Element => {
  const providerKey = provider.npi == null
                      ? "PSV:PID:" + provider.providerSetVersionId + ":" + provider.providerId
                      : "NPI:" + provider.npi;

  return <Link target="_blank" to={{ pathname: `/projects/${projectId}/provider-hub/run/${projectRunConfigurationId}/provider-profile/${encodeURIComponent(providerKey)}/` }}>
      {provider.providerName} <QesIcon iconName={QesIcons.ShareV4} description="open link in new tab" />
    </Link>;
}

// Provider Hub holds servicing providers only for the current slice of a non-zip adequacy project,
// so anything else renders as plain text rather than a link the user cannot follow.
const isProviderHubAvailable = (showProviderHubFeatureFlag: boolean,
                                project: Partial<Project>,
                                projectRunConfiguration: Partial<ProjectRunConfiguration>): boolean => {

    const showProviderHub = showProviderHubFeatureFlag
        && !!projectRunConfiguration
        && projectRunConfiguration.adequacyTemplateId != null
        && !projectRunConfiguration.isTermed
        && !projectRunConfiguration.isProjected
        && projectRunConfiguration.isServicingProviderInSnowflake
        && project?.resource?.resourceType !== ResourceType.ZipAnalysisProject
        && !isHistoricalRun(projectRunConfiguration);

    return showProviderHub;
}

// The API reports the ingestion status of the latest published run configuration, so it only
// describes the run being viewed when that run is the latest published one.
const isProviderHubDataReady = (project: Partial<Project>,
                                projectRunConfiguration: Partial<ProjectRunConfiguration>): boolean =>
    project?.servicingProviderIngestionStatus === ProjectRunStatusEnum.Succeeded
        && !!projectRunConfiguration?.isLatestPublished;

export { generateProviderHubLink, isProviderHubAvailable, isProviderHubDataReady, PROVIDER_HUB_UNAVAILABLE_TOOLTIP };
